import Image from "@/components/Image";
import styles from "./index.module.less";
export default function Logo(props) {
  const { listInfo } = props;
  return (
    <>
      {listInfo[listInfo.length - 1].cardTitle && (
        <a
          className={`${styles.logoContent} ${
            listInfo[listInfo.length - 1].href ? styles.hasLink : ""
          }`}
          href={listInfo[listInfo.length - 1].href}
          target="_blank"
        >
          {/* 卡片标识，只取最新的 */}
          {!!listInfo[listInfo.length - 1].icon?.length && (
            <Image
              className={styles.logoImg}
              alt=""
              src={listInfo[listInfo.length - 1].icon[0].url}
              width={14}
              height={14}
            ></Image>
          )}
          {listInfo[listInfo.length - 1].cardTitle}
        </a>
      )}
    </>
  );
}
